import { Component, OnInit, Input } from '@angular/core';
import { MbDialog, MbCommunication } from '@am/moebius';
import { dialogConfig } from '@modals/dialog.configure';
import { ModalDisneyPurchasePolicyComponent } from '@modals/disney-purchase-policy/disney-purchase-policy.component';

@Component({
    selector: 'ticket-purchase-policy',
    templateUrl: './ticket-purchase-policy.component.html',
    styleUrls: ['./ticket-purchase-policy.component.scss'],
    imports: [MbCommunication]
})
export class TicketPurchasePolicyComponent implements OnInit {
  @Input()
  isDisney: boolean;

  constructor(private dialog: MbDialog) {}

  ngOnInit() {}

  public openModal() {
    if (!this.dialog.isAnyDialogOpen) {
      this.dialog.open(ModalDisneyPurchasePolicyComponent, {
        ...dialogConfig,
        size: 'md',
      });
    }
  }
}
